/**
 * Asiakkaan yhteyshenkilöiden ja dokumenttilinkkien jaetut säännöt.
 *
 * Nämä ovat selaimessa ja palvelimella sama koodi tarkoituksella: syöttö
 * ehdottaa ja siistii, palvelin torjuu. Jos säännöt eläisivät kahdessa
 * paikassa, selain siistisi tagin muotoon, jonka palvelin hylkää — ja
 * käyttäjä näkisi virheen kentästä, jota hän ei muokannut.
 */
/** Tagi on nimilappu, ei lause. */
export const TAGI_MAX_PITUUS = 24;
/**
 * Enintään kahdeksan tagia per linkki.
 *
 * Raja ei ole tekninen vaan luettavuuden: rivi, jolla on kaksikymmentä
 * lappua, ei kerro mitään. Ylitys on virhe eikä hiljainen katkaisu —
 * katkaisu hukkaisi juuri sen tagin, jonka takia rivi tallennettiin.
 */
export const TAGEJA_ENINTAAN = 8;
/**
 * Yksi tagi normaalimuotoon: pienet kirjaimet, yksi välilyönti sanojen
 * välissä, ei erikoismerkkejä.
 *
 * Pienet kirjaimet siksi, että ”Sopimus” ja ”sopimus” ovat sama asia. Tämä
 * on sama riski, josta `AttributeDefinition` varoittaa vapaan avaimen
 * kohdalla — vastaus on normalisointi ja ehdotukset olemassa olevista,
 * ei kiinteä luettelo, joka tekisi uudesta dokumenttilajista migraation.
 */
export function normalisoiTagi(raaka) {
    return raaka
        .normalize('NFC')
        .toLowerCase()
        .replace(/[^\p{Letter}\p{Number} _-]/gu, ' ')
        .trim()
        .replace(/\s+/g, ' ')
        .slice(0, TAGI_MAX_PITUUS)
        .trim();
}
/**
 * Koko tagijoukko normaalimuotoon: tyhjät pois, kaksoiskappaleet pois,
 * järjestys säilyy. Lukumäärää ei rajata täällä vaan skeemassa, jotta
 * ylitys näkyy virheenä eikä katoa hiljaa.
 */
export function normalisoiTagit(raaat) {
    const tulos = [];
    for (const raaka of raaat) {
        const tagi = normalisoiTagi(raaka);
        if (tagi.length === 0 || tulos.includes(tagi))
            continue;
        tulos.push(tagi);
    }
    return tulos;
}
/**
 * Kelpaako osoite dokumenttilinkiksi: `http://` tai `https://` ja isäntä.
 *
 * Vain nämä kaksi. Linkki renderöidään klikattavaksi, joten `javascript:`
 * olisi skriptin suoritus toisen käyttäjän istunnossa ja `data:` sivu, joka
 * näyttää tältä sovellukselta olematta se. `file:` torjutaan eri syystä:
 * se ei toimi selaimesta avattuna, joten se on aina väärinkäsitys eikä
 * koskaan toimiva linkki.
 *
 * Säännöllinen lauseke eikä `new URL()`: tämä paketti käännetään ilman
 * DOM- ja Node-tyyppejä (`lib: ES2023`), koska sama koodi ajetaan
 * molemmissa. Tarkistettava sääntö on kapea, joten lauseke riittää —
 * kyse ei ole osoitteen jäsentämisestä vaan protokollan hyväksymisestä.
 */
const SALLITTU_URL = /^https?:\/\/[^\s/?#]+[^\s]*$/i;
export function onSallittuDokumenttiUrl(arvo) {
    return SALLITTU_URL.test(arvo.trim());
}
//# sourceMappingURL=asiakastiedot.js.map